<template>
  <v-form>
    <slot></slot>
    <v-text-field
      v-if="showField('propertyIdentificationCode')"
      name="propertyIdentificationCode"
      label="PIC"
      :value="value.propertyIdentificationCode"
      @input="onInput('propertyIdentificationCode', $event)"
      dense
    />
    <v-text-field
      v-if="showField('lpaUserId')"
      name="lpaUserId"
      label="UserId"
      type="number"
      :value="value.lpaUserId"
      @input="onInput('lpaUserId', Number($event))"
      dense
    />
    <v-checkbox
      v-if="showField('stockTypeBeef')"
      name="stockTypeBeef"
      label="Beef"
      :input-value="value.stockTypeBeef"
      @change="onInput('stockTypeBeef', $event)"
      dense
    />
    <v-checkbox
      v-if="showField('stockTypeSheep')"
      name="stockTypeSheep"
      label="Sheep"
      :input-value="value.stockTypeSheep"
      @change="onInput('stockTypeSheep', $event)"
      dense
    />
    <v-checkbox
      v-if="showField('nsqaAccredited')"
      name="nsqaAccredited"
      label="NSQA Accredited"
      :input-value="value.nsqaAccredited"
      @change="onInput('nsqaAccredited', $event)"
      dense
    />
    <v-text-field
      v-if="showField('nfasId')"
      name="nfasId"
      label="NFAS ID"
      :value="value.nfasId"
      @input="onInput('nfasId', $event)"
      dense
    />
    <v-text-field
      v-if="showField('nlisUserId')"
      name="nlisUserId"
      label="NLIS User ID"
      :value="value.nlisUserId"
      @input="onInput('nlisUserId', $event)"
      dense
    />
    <v-text-field
      v-if="showField('agentName')"
      name="agentName"
      label="Agent Name"
      :value="value.agentName"
      @input="onInput('agentName', $event)"
      dense
    />
    <v-text-field
      v-if="showField('agentNumber')"
      name="agentNumber"
      label="Agent Number"
      :value="value.agentNumber"
      @input="onInput('agentNumber', $event)"
      dense
    />
    <v-text-field
      v-if="showField('ausMeatEstablishmentNumber')"
      name="ausMeatEstablishmentNumber"
      label="AUS-MEAT Establishment Number"
      :value="value.ausMeatEstablishmentNumber"
      @input="onInput('ausMeatEstablishmentNumber', $event)"
      dense
    />
    <v-text-field
      v-if="showField('stateEstablishmentNumber')"
      name="stateEstablishmentNumber"
      label="State Establishment Number"
      :value="value.stateEstablishmentNumber"
      @input="onInput('stateEstablishmentNumber', $event)"
      dense
    />
    <v-text-field
      v-if="showField('nlisEstablishmentNumber')"
      name="nlisEstablishmentNumber"
      label="NLIS Establishment Number"
      :value="value.nlisEstablishmentNumber"
      @input="onInput('nlisEstablishmentNumber', $event)"
      dense
    />
    <v-text-field
      v-if="showField('gs1CompanyPrefix')"
      name="gs1CompanyPrefix"
      label="GS1 Company Prefix"
      :value="value.gs1CompanyPrefix"
      @input="onInput('gs1CompanyPrefix', $event)"
      dense
    />
    <v-text-field
      v-if="showField('gs1GlobalLocationNumber')"
      name="gs1GlobalLocationNumber"
      label="GS1 Global Location Number"
      :value="value.gs1GlobalLocationNumber"
      @input="onInput('gs1GlobalLocationNumber', $event)"
      dense
    />
    <template v-if="showField('chains')">
      <p class="font-weight-bold">Chains</p>
      <v-card v-for="(chain, i) of value.chains" :key="i" outlined class="mb-2">
        <v-card-actions>
          <v-btn
            @click="removeChain(i)"
          >
            <v-icon>delete</v-icon>
            Remove
          </v-btn>
        </v-card-actions>
        <v-card-text>
          <v-text-field
            label="Species"
            :name="`chain${i + 1}Species`"
            :value="value.chains[i].species"
            @change="onInput(`chains[${i}].species`, $event)"
            hint="e.g. Sheep"
            dense
            class="pb-3"
          />
          <v-text-field
            label="Chain Number"
            :name="`chain_${i + 1}_chainNumber`"
            :value="value.chains[i].chainNumber"
            @input="onInput(`chains[${i}].chainNumber`, $event)"
            hint="e.g. 3"
            dense
            class="pb-3"
          />
          <v-text-field
            label="Chain Name"
            :name="`chain_${i + 1}_chainName`"
            :value="value.chains[i].chainName"
            @input="onInput(`chains[${i}].chainName`, $event)"
            hint="e.g. Good Sheep Chain"
            dense
            class="pb-3"
          />

          <v-subheader>Electrical Inputs</v-subheader>
          <div v-for="electricalInput of electricalInputs" :key="electricalInput.key">
            <v-divider class="my-3" />
            <div v-for="y of [1, 2, 3]" :key="`chain_${i}_${electricalInput.key}_${y}`">
              <div v-show="y === 1 || value.chains[i][`${electricalInput.key}${y - 1}Enabled`] || value.chains[i][`${electricalInput.key}${y}Enabled`]">
                <v-checkbox
                  :label="`${electricalInput.label} ${y}`"
                  :name="`chain_${i + 1}_${electricalInput.key}${y}Enabled`"
                  :input-value="value.chains[i][`${electricalInput.key}${y}Enabled`]"
                  @change="onInput(`chains[${i}]['${electricalInput.key}${y}Enabled']`, $event)"
                  dense
                />
                <v-text-field
                  v-show="value.chains[i][`${electricalInput.key}${y}Enabled`]"
                  :label="`${electricalInput.label} ${y} Details`"
                  :name="`chain_${i + 1}${electricalInput.key}${y}Value`"
                  :value="value.chains[i][`${electricalInput.key}${y}Value`]"
                  @input="onInput(`chains[${i}]['${electricalInput.key}${y}Value']`, $event)"
                  hint="Add any details here."
                  dense
                />
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
      <v-btn
        depressed
        tile
        class="ma-0"
        @click="addChain"
      >
        <v-icon>
          add
        </v-icon>
        Add chain
      </v-btn>
    </template>
  </v-form>
</template>

<script>
import gql from 'graphql-tag'
import { tap, cloneDeep, set } from 'lodash'

export default {
  name: 'RegistrationActivityDetailsForm',

  props: {
    value: {
      type: Object,
      required: true
    },
    memberType: {
      type: String,
      required: true
    }
  },

  data: () => ({
    electricalInputs: [
      { key: 'immobiliser', label: 'Immobiliser' },
      { key: 'stimulator', label: 'Stimulator' },
      { key: 'hidePuller', label: 'Hide Puller' }
    ],
    memberTypeDetails: {
      relevantDetails: []
    }
  }),

  apollo: {
    memberTypeDetails: {
      query: gql`query GetMemberType($filter: FilterFindOneMemberTypeInput!) {
        memberTypeDetails: memberTypeFindOne(filter: $filter) {
          _id
          value
          relevantDetails
        }
      }`,
      variables () {
        return {
          filter: {
            value: this.memberType
          }
        }
      },
      error (e) { this.$emit('error', e) }
    }
  },

  methods: {
    showField (field) {
      return this.memberTypeDetails.relevantDetails.includes(field)
    },
    addChain () {
      this.$emit('input', tap(cloneDeep(this.value), v => v.chains.push({})))
    },
    removeChain (i) {
      this.$emit('input', tap(cloneDeep(this.value), v => v.chains.splice(i, 1)))
    },
    onInput (key, value) {
      const o = { ...this.value }
      set(o, key, value)
      this.$emit('input', o)
    }
  }
}
</script>
